import React, { ReactNode, PureComponent } from 'react'
import ReactDOM from 'react-dom'
import classNames from 'classnames'
import { Fade } from './animation'

import Portal from './portal'

export interface IToastProps {
  text?: string
  className?: string
  duration?: number
  onClose?: () => void
  close?: () => void
  visible: boolean
  getContainer?: () => HTMLElement
}

export type TToastFunc = (
  config: Partial<IToastProps>,
  duration?: number,
  onClose?: () => void
) => {
  hide?: () => void
}
const containerName = '__toast_container'
export default class ToastMessager extends PureComponent<IToastProps> {
  closeTimer?: number

  static show: TToastFunc

  static defaultProps: Partial<IToastProps> = {
    duration: 1500,
    visible: false,
  }

  componentDidMount() {
    this.startCloseTimer()
  }

  componentDidUpdate(prevProps: IToastProps) {
    const { duration } = this.props
    if (duration !== prevProps.duration) {
      this.startCloseTimer()
    }
  }

  startCloseTimer() {
    const { duration } = this.props
    if (duration) {
      this.closeTimer && clearTimeout(this.closeTimer)
      this.closeTimer = window.setTimeout(() => {
        this.handleClose()
      }, duration)
    }
  }

  handleClose() {
    const { onClose, close } = this.props
    onClose && onClose()
    close && close()
  }

  getContainer = (): HTMLElement => {
    const { getContainer } = this.props
    if (getContainer) {
      return getContainer()
    }
    const container = document.createElement('div')
    document.body.appendChild(container)
    return container
  }

  getComponent() {
    const { className, text, visible } = this.props
    return (
      <>
        <Fade in={visible} timeout={200} unmountOnExit>
          <div className="toast-wrap">
            <div className={classNames('toast', className)}>
              <div className="toast-content">
                <div className="toast-text">{text}</div>
              </div>
            </div>
          </div>
        </Fade>
        <style jsx>
          {`
            .show {
              opacity: 1;
            }
            .toast-wrap {
              position: fixed;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
              z-index: 999999;
              width: 100%;
              height: 100%;
              pointer-events: none;
            }
            .toast {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate3d(-50%, -50%, 0);
              background: rgba(0, 0, 0, 0.5);
              padding: 20px 40px;
            }

            .toast-content {
            }

            .toast-text {
              font-size: 16px;
              line-height: 1;
              color: #ffffff;
            }
          `}
        </style>
      </>
    )
  }

  render() {
    return (
      <Portal getContainer={this.getContainer}>{this.getComponent()}</Portal>
    )
  }
}

export function openToast(config: Partial<IToastProps>) {
  const oldDiv = document.getElementById(containerName)
  if (oldDiv) {
    return {}
  }

  const div = document.createElement('div')
  div.id = containerName
  document.body.appendChild(div)

  function render(props: IToastProps) {
    ReactDOM.render(<ToastMessager {...props} />, div)
  }

  function close() {
    render({
      ...(config as IToastProps),
      getContainer: () => div,
      // @ts-ignore
      onClose: destory.bind(this),
      visible: false,
    })
  }

  function destory() {
    const unmountResult = ReactDOM.unmountComponentAtNode(div)
    if (unmountResult && div.parentNode) {
      div.parentNode.removeChild(div)
    }
  }

  render({
    ...(config as IToastProps),
    // @ts-ignore
    onClose: destory.bind(this),
    getContainer: () => div,
    close,
    visible: true,
  })

  return {
    hide: close,
  }
}

ToastMessager.show = (config, duration) =>
  openToast({
    ...config,
    duration,
  })
